module.exports = ".row {\n    cursor: pointer;\n  }\n  \n  .row:hover {\n    background-color: rgba(0,0,0,0.2);\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/search-sterling/search-sterling.css
// module id = ./src/app/components/search-sterling/search-sterling.css
// module chunks = main